module.exports = __webpack_public_path__ + "static/media/accord-healthcare.c4abb97b.png";